import OpenCloseAnimation from './OpenCloseAnimation'

export default OpenCloseAnimation
